module.exports = __webpack_public_path__ + "static/media/attribute_resist_normal.84a50cab.png";